module.exports = __webpack_public_path__ + "static/img/2.8c650926.png";